<template>
  <div class="button-section-container">
    <div class="content-section">
      <ValidationObserver ref="observer">
        <v-form @submit.prevent="submit">
          <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
          <ValidationProvider
            :id="whitelabel.authentication.login.fieldName"
            v-slot="{ errors }"
            :name="whitelabel.authentication.login.fieldName"
            :rules="whitelabel.authentication.login.validation"
          >
            <v-text-field
              v-model="uniqueIdentifier"
              :label="whitelabel.authentication.login.fieldTitle"
              :error-messages="errors"
            />
          </ValidationProvider>
          <ValidationProvider
            id="password"
            v-slot="{ errors }"
            name="password"
            rules="required"
          >
            <v-text-field
              v-model="password"
              :append-icon="showPassword ? icons.mdiEye : icons.mdiEyeOff"
              :type="showPassword ? 'text' : 'password'"
              label="Password"
              :error-messages="errors"
              @click:append="showPassword = !showPassword"
            />
          </ValidationProvider>
          <v-row no-gutters>
            <v-col cols="12">
              <a @click="forgotPassword" class="forgot-password"
                >Forgot Password?</a
              >
            </v-col>
          </v-row>

          <div class="signin-button">
            <GradientButton
              type="submit"
              @gradientButtonClicked="submitClicked"
              :title="'LOG IN'"
            />
          </div>
        </v-form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
  import loginService from '../../services/LoginService';

  export default {
    name: 'SignInWithNumber',
    props: {},
    methods: {
      forgotPassword() {
        this.$emit('forgotPassword');
      },
      submit() {
        this.$refs.observer.validate().then(valid => {
          if (valid) {
            this.buttonLoading = true;
            this.login();
          } else {
            const errors = this.$refs.observer.ctx.errors;
            document
              .getElementById(
                Object.keys(errors).find(field => errors[field].length)
              )
              .scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        });
      },
      onError(error) {
        this.$emit('onError', error);
      },
      login() {
        const uniqueIdentifier = this.uniqueIdentifier;
        const password = this.password;
        loginService
          .login(
            this.uniqueIdentifier,
            this.password,
            this.$apollo,
            this.$store
          )
          .then(result => {
            if (result.message?.includes('GraphQL error')) {
              throw result;
            }
            const login = result.data.login;
            const accessToken = login.accessToken;
            const refreshToken = login.refreshToken;
            const testatorId = login.testatorId;
            const userId = login.userId;
            const willCountry = login.willCountry;
            const companyId = login.companyId;

            this.$store.dispatch('login', {
              accessToken,
              refreshToken,
              testatorId,
              userId,
              willCountry,
              companyId,
            });
            loginService.setSentryUser(userId);
            loginService.redirectToNext(this.$router);
          })
          .catch(error => {
            this.onError(error);
          });
      },
      handleEmailSignUp() {
        this.showContent = !this.showContent;
        this.$emit('onError', null);
      },
      submitClicked() {
        // Do Nothing as it needs to submit
      },
    },
    data() {
      return {
        showContent: false,
        uniqueIdentifier: this.prepopulatedEmail,
        password: null,
        errorMessage: null,
        showPassword: false,
        buttonLoading: false,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .button-section-container {
    width: 100%;
    .button-section {
      margin-bottom: 24px;
    }
    .content-section {
      width: 100%;
      .signin-button {
        margin-top: 52px;
      }
      a {
        font-size: 12px;
        font-weight: 500;
        line-height: 18px;
        text-align: left;
        color: #282828;
      }
    }

    .forgot-password {
      text-decoration: underline;
    }
  }
</style>
